import React, { Component } from 'react';
import Card from './Card';

class SemanticTableHousing extends Component {


  render() {

      return (
        <Card title={this.props.title} body={
  <table class="table table-condensed" style={{"border-collapse": "collapse"}}>
  <thead>
      <tr>
      {this.props.dataColumns.map(function(column, i){
        if (column['priority'] === 'high'){
          return <th>{column['prettyName']}</th>;
        }})}
      </tr>
  </thead>
  <tbody>
  {this.props.tableData.map((row) =>
     <>
      <tr data-toggle="collapse" id={'row' + row['id']} data-target={'#id' + row['id']} class="accordion-toggle">
            {this.props.dataColumns.map(function(column, i){
              if (column['priority'] === 'high'){
                return <th>{row[column['name']]}</th>;
              }
            })}
        </tr>
        <tr>
            <td colspan="6"  style={{"padding": "0"}}>
              <div class="accordian-body collapse" id={'id' + row['id']}>
              <table class="table table-striped table-dark">
                <tbody>
                  {this.props.dataColumns.map(function(column, i){
                    if (column['priority'] !== 'high' && row[column['name']]){
                      return <tr><td><b>{column['prettyName']}:</b></td><td>{row[column['name']]}</td></tr>;
                    }})}
                  </tbody>
                </table>
              </div>
            </td>
        </tr>
    </>
  )}
</tbody>
</table>
}></Card>


	     )
  }
}

export default SemanticTableHousing;
